/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';

import './ProfileIdentityCard.scss';
import UserImage from '../../Content/User/UserDisplay/UserImage/UserImage';
import SVGFromCloudinary from '../../Elements/SVGFromCloudinary/SVGFromCloudinary';
import { PageContext } from '../../../contexts/ContextCreator';
import CommunityInviteButton from '../../Community/CommunityInviteButton/CommunityInviteButton';
import CommunityUserCallToActions from '../../CallToAction/CommunityUserCallToActions/CommunityUserCallToActions';
import { MYSTERY_WOMAN_IMAGE_PATH } from '../../../utilities/images';
import EditButton from '../UserProfile/Modules/EditButton/EditButton';
import EmptyMessage from '../UserProfile/Modules/EmptyMessage/EmptyMessage';

export default class ProfileIdentityCard extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            name: props.name,
            logo: props.logo,
            credential: props.credential,
            aboutMe: props.aboutMe,
            website: props.website,
            profileUserId: props.profileUserId,
        };
    }

    static propTypes = {
        name: PropTypes.string,
        logo: PropTypes.shape({
            src: PropTypes.string,
            alt: PropTypes.string,
        }),
        credential: PropTypes.string,
        aboutMe: PropTypes.string,
        website: PropTypes.string,
        profileUserId: PropTypes.number,
        isPublic: PropTypes.bool,
        isVip: PropTypes.bool,
    };

    static defaultProps = {};

    static contextType = PageContext;

    // USER IMAGE
    //= =============================================================================
    renderUserImage = () => {
        const isDefaultLogo =
            this.state.logo && this.state.logo.src === MYSTERY_WOMAN_IMAGE_PATH;
        const editViewClass =
            isDefaultLogo && !this.props.isPublic ? 'edit-view' : '';
        return (
            <div
                className={`user-image-display ${editViewClass}`}
                onClick={this.openModal}
            >
                {(isDefaultLogo && !this.props.isVip) ? (
                    <SVGFromCloudinary
                        cloudinaryID={this.state.logo && this.state.logo.src}
                    />
                ) : (
                    <UserImage
                        image={this.state.logo}
                        iconSize={160}
                        isVip={this.props.isVip}
                    />
                )}
                {isDefaultLogo && !this.props.isPublic && (
                    <span className="edit-overlay-text">
                        Add
                        <br />
                        Image
                    </span>
                )}
            </div>
        );
    };

    // USER NAME DISPLAY
    //= =============================================================================
    renderUserNameDisplay = () => {
        let nameDisplay = !this.props.isPublic ? (
            <button className="username-display" onClick={this.openModal}>
                + Add your name
            </button>
        ) : (
            <h3 className="username-display">{this.props.username}</h3>
        );

        if (this.state.name && this.state.name.length > 0) {
            nameDisplay = (
                <h3 className="username-display">{this.state.name}</h3>
            );
        }
        return nameDisplay;
    };

    // USER CREDENTIAL
    //= =============================================================================
    renderCredential = () => {
        let credentialComponent = !this.props.isPublic && (
            <button
                className="empty-field-call-to-action credential"
                onClick={this.openModal}
            >
                + Add a tagline
            </button>
        );
        if (this.state.credential && this.state.credential.length > 0) {
            credentialComponent = (
                <p className="description-text credential">
                    {this.state.credential}
                </p>
            );
        }
        return credentialComponent;
    };

    // ABOUT ME SECTION
    //= =============================================================================
    renderAboutMeSection = () => {
        let aboutMeContent = !this.props.isPublic && (
            <div className="about-me-section">
                <h6 className="about-me-title">About me</h6>
                <EmptyMessage
                    className="add-about-me-component"
                    handleClick={this.openModal}
                    text="Add your elevator pitch here."
                />
            </div>
        );
        if (this.state.aboutMe && this.state.aboutMe.length > 0) {
            aboutMeContent = (
                <div className="about-me-section">
                    <h6 className="about-me-title">About me</h6>
                    <p className="description-text about-me">
                        {this.state.aboutMe}
                    </p>
                </div>
            );
        }
        return aboutMeContent;
    };

    // PERSONAL WEBSITE SECTION
    //= =============================================================================
    renderPersonalWebsiteSection = () => {
        let personalWebsiteSection = !this.props.isPublic && (
            <button
                className="empty-field-call-to-action personal-website"
                onClick={this.openModal}
            >
                + Add a website
            </button>
        );
        if (this.state.website && this.state.website.length > 0) {
            personalWebsiteSection = (
                <a
                    className="empty-field-call-to-action personal-website break-word"
                    href={this.state.website}
                    target="_blank"
                    rel="noreferrer"
                >
                    {this.state.website}
                </a>
            );
        }
        return personalWebsiteSection;
    };

    renderPrimaryButton = (relationsToUser, profileUser) => {
        if (
            relationsToUser &&
            relationsToUser.connectionStatus === 'connected'
        ) {
            return (
                <CommunityUserCallToActions
                    buttonsToRender={['MESSAGE']}
                    connectionStatus={relationsToUser.connectionStatus}
                    inputStyle="connect-message-button"
                    wrapperCssClass="connect-message-button"
                    user={profileUser}
                />
            );
        }

        return (
            <CommunityUserCallToActions
                buttonsToRender={['CONNECT']}
                buttonType="purple-medium-white"
                connectionStatus={relationsToUser.connectionStatus}
                inputStyle="connect-message-button"
                user={profileUser}
                wrapperCssClass="connect-message-button"
            />
        );
    };

    renderPublicButtons = () => {
        const { relationsToUser, name, profileUserId, logo, credential } =
            this.props;
        const isGroupAdmin =
            this.context.groups && this.context.groups.isGroupAdmin();
        const profileUser = {
            username: name,
            userId: profileUserId,
            image: logo,
            credential,
        };
        return (
            <div className="button-sections">
                <div className="primary-btn-div">
                    {this.renderPrimaryButton(relationsToUser, profileUser)}
                </div>
                {isGroupAdmin && (
                    <CommunityInviteButton
                        buttonType="wired-blue"
                        inputStyle="community-button community-invite-button"
                        inviteType="group"
                        user={profileUser}
                        value="Invite to group"
                    />
                )}
            </div>
        );
    };

    openModal = () => {
        if (this.props.isPublic) {
            return;
        }
        const modalProps = {
            ...this.state,
            onSuccess: this.updateStateCallBack,
        };
        this.context.modalTrigger('userProfileIdentity', modalProps);
    };

    updateStateCallBack = (updatedProps) => {
        this.setState({ ...updatedProps });
    };

    // RENDER SECTION
    //= =============================================================================
    render() {
        return (
            <section className="component-Users-ProfileIdentityCard">
                {!this.props.isPublic && (
                    <EditButton
                        className="edit-button"
                        handleClick={this.openModal}
                    />
                )}
                {this.renderUserImage()}
                {this.renderUserNameDisplay()}
                {this.renderCredential()}
                {this.renderAboutMeSection()}
                {this.renderPersonalWebsiteSection()}
                {this.props.isPublic && this.renderPublicButtons()}
            </section>
        );
    }
}
